// Headless fetch hook for the /plan calibration card (one call per drill
// grain). Returns null while loading and on failure — the card is context,
// not the page's primary content, so an absent card beats a broken page.

import { useEffect, useState } from "react";

import type { CalibrationCardData } from "../data/adapter";
import { useDataAdapter } from "../data/DataAdapterContext";

export function usePlanCalibration(
  grain: "company" | "rep" | "bucket",
  key?: string,
): CalibrationCardData | null {
  const adapter = useDataAdapter();
  const [data, setData] = useState<CalibrationCardData | null>(null);

  useEffect(() => {
    let cancelled = false;
    setData(null);
    const opts =
      grain === "rep"
        ? { repId: key }
        : grain === "bucket"
          ? { bucketId: key }
          : undefined;
    adapter
      .getPlanCalibration(grain, opts)
      .then((d) => {
        if (!cancelled) setData(d);
      })
      .catch((err: unknown) => {
        // eslint-disable-next-line no-console -- surfaced for debugging; the card degrades to absent.
        console.error("plan.calibration_card.load_failed", { grain, key, err });
        if (!cancelled) setData(null);
      });
    return () => {
      cancelled = true;
    };
  }, [adapter, grain, key]);

  return data;
}
